import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-show-results',
    templateUrl: './show-results.component.html',
    styleUrls: ['./show-results.component.css']
})
export class ShowResultsComponent implements OnInit {
    @Input() showResultsPage = false;
    @Input() deploymentResults: any;
    @Input() isTransform = true;
    executorDeploymentPlans = [];
    entityDeploymentPlans = [];
    dataMigrationPlans = [];
    requestModel: any;

    columns = ['API', 'Version', 'API Generation', 'Deployment', 'API Gateway', 'Database', 'Data Migration'];
    entityOnlyColumns = ['Service', 'Version', 'API Generation', 'Deployment', 'API Gateway'];
    dataMigrationColumns = ['Table/Entity', 'Database Setup', 'Data Migration'];
    executorColumns = ['Service', 'Version', 'API Generation', 'Deployment', 'API Gateway'];

// , 'End Points'
    constructor() {
    }

    ngOnInit() {
        if (this.deploymentResults) {
            if (this.deploymentResults.executorDeploymentPlans !== null) {
                this.executorDeploymentPlans = this.deploymentResults.executorDeploymentPlans;
            }
            if (this.deploymentResults.entityDeploymentPlans !== null) {
                this.entityDeploymentPlans = this.deploymentResults.entityDeploymentPlans;
            }
            if (this.deploymentResults.dataMigrationPlans !== null) {
                this.dataMigrationPlans = this.deploymentResults.dataMigrationPlans;
            }
            if (this.deploymentResults.requestModel !== null) {
                this.requestModel = this.deploymentResults.requestModel;
            }
        }
    }

}
